import { render, staticRenderFns } from "./Musicwow.vue?vue&type=template&id=10fe66ee&scoped=true"
import script from "./Musicwow.vue?vue&type=script&lang=js"
export * from "./Musicwow.vue?vue&type=script&lang=js"
import style0 from "./Musicwow.vue?vue&type=style&index=0&id=10fe66ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe66ee",
  null
  
)

export default component.exports